var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIllustrationFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 93,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.923 35A13.885 13.885 0 0066 29.667C66 21.58 59.046 15 50.5 15S35 21.58 35 29.667c0 1.882.39 3.677 1.077 5.333h28.846z",
    fill: "#F47735",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 34)",
    stroke: "#2B2B2B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 80,
    height: 12,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.252 13.112l-20.7 19.803a9 9 0 00-2.778 6.503h0V58h-9.51V38.926a8 8 0 00-2.439-5.751h0l-20.75-20.063h56.177z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M.5.5v34M98.5.5v34M10.5 18.5v34M88.5 18.5v34"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    fillRule: "nonzero",
    d: "M32.903 52.94l2.337-2.672 2.672 2.34-2.337 2.673zM38.248 57.615l2.338-2.672 2.672 2.34-2.338 2.673zM43.594 62.29l2.337-2.672 2.672 2.34-2.337 2.673z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 25C70.711 25 66 20.289 66 14.5S70.711 4 76.5 4 87 8.711 87 14.5 82.289 25 76.5 25zM30.5 21C24.711 21 20 16.289 20 10.5S24.711 0 30.5 0 41 4.711 41 10.5 36.289 21 30.5 21z",
    fill: "#F47735",
    fillRule: "nonzero"
  }))));
}

export default SvgIllustrationFilter;